import { render, staticRenderFns } from "./ForecastingPage.vue?vue&type=template&id=ce794b9e&"
import script from "./ForecastingPage.vue?vue&type=script&lang=js&"
export * from "./ForecastingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports